import React from "react";
import "./Heading.css";

export default function Heading({ heading }) {
  return <div className="heading">{heading}</div>;
}
